import * as React from 'react'
import { StickyStatus, Offset } from './types'

export function useStickyFromContext(
  contextRef: React.RefObject<HTMLElement | null>,
  { top = 0 }: Offset = {},
): StickyStatus {
  const [state, setState] = React.useState<StickyStatus>(StickyStatus.PreSticky)

  React.useEffect(() => {
    if (!contextRef.current) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        const contextBoxTop = entry.boundingClientRect.top

        setState((prevState) => {
          switch (prevState) {
            case StickyStatus.PreSticky:
              // if we are not yet sticky and the top of the context exits the viewport from
              // the top (meaning we scrolled downard enough to become sticky) then the
              // target become "fixed" to the top of the viewport (sticky-like behaviour)
              if (contextBoxTop + top < 0) {
                return StickyStatus.Sticky
              }
              break
            case StickyStatus.Sticky:
              // if we are sticky and the top of the context enters the viewport from
              // the top (meaning we scrolled upward enough to overflow the context)
              // then the targets stops being stick and its position if fixed to the
              // top of the context with 'absolute' positioning
              if (contextBoxTop + top > 0) {
                return StickyStatus.PreSticky
              }
              break
          }
          return prevState
        })
      },
      {
        root: null,
        threshold: 0,
      },
    )

    observer.observe(contextRef.current)

    return () => observer.disconnect()
  }, [contextRef.current, top])

  return state
}
